




import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Start extends Vue {
	public async mounted(): Promise<void> {
		this.$router.push(`/dashboard`);
	}

}
